import React from "react";
import {
  Button,
  Description,
  SubTitle,
} from "../../Components/CustomComponents";
import AccountLayout from "../../Components/Layouts/AccountLayout";
import { ACCOUNT_ENUM } from "./Route";

export default function PortalSelect({ setPage, setLoginAs }) {
  const choose = (portal) => {
    setLoginAs(portal);
    setPage(ACCOUNT_ENUM.LOGIN);
  };

  return (
    <AccountLayout>
      <SubTitle text="Sign in" classes="mb-2" />
      <Description
        text="Choose how you want to sign in."
        classes="text-center fs-7 mb-4"
      />
      <div
        className="d-flex flex-column gap-3"
        style={{ width: "300px", maxWidth: "100%" }}
      >
        <Button
          text="Login as Admin"
          onClick={() => choose("admin")}
          classes="mb-0"
        />
        <Button
          text="Login as Agent"
          onClick={() => choose("agent")}
          classes="mb-0"
        />
      </div>
    </AccountLayout>
  );
}
